/* Collection page: sort select (Shopify sort_by) and quick view (Section Rendering API into the design's 960 px Dialog). */
(function () {
  'use strict';
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-psa-sort]');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-psa-qv]');
    if (!btn) return;
    e.preventDefault();
    var dlg = document.getElementById('PsaQuickView');
    if (!dlg) return;
    var url = btn.getAttribute('data-psa-qv');
    btn.setAttribute('aria-busy', 'true');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=psa-quick-view')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-psa-product]');
        var body = dlg.querySelector('.psa-dlg__body');
        body.innerHTML = '';
        if (content) body.appendChild(content);
        if (window.psaInitProducts) window.psaInitProducts(body);
        var opener = document.querySelector('[data-psa-open-proxy]');
        if (!opener) { opener = document.createElement('button'); opener.type = 'button'; opener.hidden = true; opener.setAttribute('data-psa-open-proxy', ''); document.body.appendChild(opener); }
        opener.setAttribute('data-psa-open', 'PsaQuickView');
        opener.click();
        dlg._psaOpener = btn;
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });
  // After adding to the cart from the quick view: close it (the toast is shown by psa-theme.js)
  document.addEventListener('psa:added', function (e) {
    var dlg = document.getElementById('PsaQuickView');
    if (dlg && !dlg.hidden && dlg.contains(e.target)) { var c = dlg.querySelector('[data-psa-close]'); if (c) c.click(); }
  });
})();
/* Tab row on phones: the fade at the right edge disappears when the row is scrolled to its end or does not scroll (SEO audit, 5 Oct 2026). */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-m~="tabs-scroll"]');
  if (!wrap) return;
  var box = wrap.querySelector('[data-psa-tabs-scroll]');
  if (!box) return;
  function update() {
    var atEnd = box.scrollLeft + box.clientWidth >= box.scrollWidth - 1;
    if (atEnd) wrap.setAttribute('data-scroll-end', ''); else wrap.removeAttribute('data-scroll-end');
  }
  box.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
